export interface ExternalLinkIconProps{
  color?:string;
}

const ExternalLinkIcon = ({color}: ExternalLinkIconProps) => {
  return (
    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.5 3H3.5C2.96957 3 2.46086 3.21071 2.08579 3.58579C1.71071 3.96086 1.5 4.46957 1.5 5V15C1.5 15.5304 1.71071 16.0391 2.08579 16.4142C2.46086 16.7893 2.96957 17 3.5 17H13.5C14.0304 17 14.5391 16.7893 14.9142 16.4142C15.2893 16.0391 15.5 15.5304 15.5 15V9M8.5 10L17.5 1M17.5 1H12.5M17.5 1V6" stroke={color === "white" ? "#fff" : "#0A676D"} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  )
}

export default ExternalLinkIcon;